angular.module('zc.commonApi')

.factory "InvoiceAdjustments", ($resource, $q, BaseProjectCrudService) ->
  class InvoiceAdjustments extends BaseProjectCrudService

  new InvoiceAdjustments(
    $resource
    $q
    "/api/projects/:projectId/invoice_adjustments/:id"
    "invoice_adjustment"
    "invoice_adjustments"
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/invoice_adjustments.service.coffee